import {PropsWithChildren} from 'react';

import {classNames} from '../../../../../../../util/css';
import {printPdfPageAttribute} from '../pdf-preview-const';

import * as styles from './preview-page.scss';

type PropsType = PropsWithChildren<Record<string, unknown>> & {
    className?: string;
};

export function PreviewPage(props: PropsType): JSX.Element {
    const {children, className} = props;

    return (
        <div
            className={classNames(styles.PreviewPage, className)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...{[printPdfPageAttribute]: printPdfPageAttribute}}
        >
            {children}
        </div>
    );
}
